import { render, staticRenderFns } from "./FeaturedChefs.vue?vue&type=template&id=6fe7c84e&"
import script from "./FeaturedChefs.vue?vue&type=script&lang=js&"
export * from "./FeaturedChefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports